export default __webpack_public_path__ + "static/media/bookmark-filled.f766e32e.svg";